import React from 'react';
import { StyleSheet, Text, TouchableHighlight, View } from 'react-native';
import Throb from './Throb';

export default class LargeButton extends React.Component {
    constructor(props) {
      super(props);

      // props include:
      // - onPress()
      // - buttonStyle
      // - title

    }

    _pressedButton() {
      this.props.onPress();
    }

    render() {
      let coverStyle = styles.largeButton;
      if (!!this.props.buttonStyle) {
        coverStyle = this.props.buttonStyle;
      }
      if (!!(this.props.smaller)) {
        coverStyle = styles.smallerButton;
      }
      if (!!(this.props.main)) {
        coverStyle = styles.actionButton;
      }
      if (!!(this.props.hidden)) {
        return (<View style={{width: this.props.smaller ? 150 : 250}}></View>);
      } else {
        return (
          <TouchableHighlight onPress={ () => this._pressedButton() } underlayColor="white">
            <View style={coverStyle}>
              <Throb disabled={this.props.nothrob}>
                <View style={{padding: 5, justifyContent: 'center', alignItems: 'center'}}>
                  <Text style={styles.smallButtonText}>{this.props.title}</Text>
                </View>
              </Throb>
            </View>
          </TouchableHighlight>
        )
      }
    }
}


const styles = StyleSheet.create({

  largeButton: {
    backgroundColor:'#445079',
    justifyContent: 'center',
    padding: 15,
    flexDirection: 'column',
    margin: 10,
    width: 300, 
    borderRadius: 20
  },

  actionButton: {
    backgroundColor:'#D29831',
    justifyContent: 'center',
    padding: 10,
    flexDirection: 'column',
    margin: 10,
    width: 300,
    borderRadius: 20
  },

  smallerButton: {
    backgroundColor:'#445079',
    justifyContent: 'center',
    padding: 4,
    flexDirection: 'column',
    margin: 5,
    width: 150
  },

  smallButtonText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 18
  }

});
